/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle"; 
import Address from "./_components/Address";
import BankDetails from "./_components/BankDetails";
import Password from "./_components/Password";
import Webhooks from "./_components/Webhooks"; // New Component
import ShippingIntegrations from "./_components/ShippingIntegrations";

const Settings: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Address");
  const roles = [
    "Address",
    "Bank Details",
    "Password",
    "Webhooks", // Added for Webhook Management
    "Shipping Integrations",
  ];

  return (
    <div className="p-6 space-y-4 flex flex-col justify-center items-center">
      <h1 className="text-3xl text-[#212121] ">
        Settings {">"} {activeRole}
      </h1>
      <RoleToggle
        options={roles}
        active={activeRole}
        onChange={setActiveRole}
      />

      <div className="w-full max-w-4xl mt-6">
        {activeRole === "Address" && <Address />}
        {activeRole === "Bank Details" && <BankDetails />}
        {activeRole === "Password" && <Password />}
        {activeRole === "Webhooks" && <Webhooks />}
        {activeRole === "Shipping Integrations" && <ShippingIntegrations />}
      </div>
    </div>
  );
};
export default Settings;